import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { styled } from '@linaria/react';
import { useToastController } from '@daedalus/atlas/context/toastController';
import { Spinner } from '@daedalus/atlas/Spinner';
import { Text } from '@daedalus/atlas/Text';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, AnalyticsContext, Category, Entity, Team } from '@daedalus/core/src/analytics/types/Events';
import { getLastLoginUrl } from '@daedalus/core/src/auth/business/persistData';
import { updateUser } from '@daedalus/core/src/auth/components/FetchUser';
import { getUser } from '@daedalus/core/src/auth/modules/selectors';
import { redirectUsersFromCallbackUrl } from '@daedalus/core/src/auth/modules/thunks';
import { Hub } from '@daedalus/core/src/auth/services';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import vioGif from './vio.gif';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w3h3wo5",
  propsAsIs: false
});
const LoaderBox = /*#__PURE__*/styled('div')({
  name: "LoaderBox",
  class: "lak6lox",
  propsAsIs: false
});
const VioLoader = () => <LoaderBox>
    <img src={vioGif} width="150" alt="vio-logo-gif" />
    <Text variant="titleL">
      <FormattedMessageWrapper id="cognitoPasswordlessLoader.text" defaultMessage="Signing in..." />
    </Text>
  </LoaderBox>;
export const CognitoPasswordlessLoader = () => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const history = useHistory();
  const toast = useToastController();
  const {
    brandIsVio
  } = useBrand();
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({
      payload
    }) => {
      switch (payload.event) {
        case 'signInWithRedirect':
          updateUser({
            dispatch
          });
          break;
        case 'signInWithRedirect_failure':
          console.error('signInWithRedirect_failure');
          break;
      }
    });
    return unsubscribe;
  }, [dispatch]);

  // Cognito authentication handler: redirect the user after the user is authenticated
  useEffect(() => {
    const redirectUserToPreviousUrl = () => {
      if (user) {
        dispatch(redirectUsersFromCallbackUrl({
          history,
          user
        }));
      } else {
        // handle when user isn't set usually when the user cancels the signin
        const lastLoginUrl = getLastLoginUrl();
        const url = new URL(lastLoginUrl || location.origin);
        history.replace(url.pathname + url.search);
      }
    };
    const timer = setTimeout(() => {
      toast.open(<FormattedMessageWrapper id="crashPage.messageTitle" defaultMessage="Uh oh, something went wrong" />);
      redirectUserToPreviousUrl();
      dispatch(trackEvent({
        category: Category.System,
        entity: Entity.Authentication,
        action: Action.Errored,
        team: Team.Retention,
        analyticsContext: {
          [AnalyticsContext.ErrorContext]: {
            errorType: 'authentication_callback_stuck',
            errorMessage: 'The user seems to get stuck on the authentication callback page'
          }
        }
      }));
    }, 10000);
    if (user) {
      clearTimeout(timer);
      redirectUserToPreviousUrl();
    }
    return () => {
      clearTimeout(timer);
    };
  }, [user, dispatch, history]);
  return <Wrapper>{brandIsVio ? <VioLoader /> : <Spinner size={100} />}</Wrapper>;
};

require("./CognitoPasswordlessLoader.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CognitoPasswordlessLoader.tsx");